<script setup lang="ts">
import TabMenu from "@/components/TabMenu.vue";
import {IBaseMenuItem} from "@/models";

const props = defineProps({
  menuItems: {type: Array as () => IBaseMenuItem[], default: []},
});
</script>

<template>
  <div id="ct" class="flex-layout-body">
    <nav class="nav nav-files">
      <tab-menu :items="menuItems" :li="false" :depths="4" />
    </nav>
    <!-- [D] 선택 된 순서 data-file="숫자" -->
    <div class="file-content" data-file="1">
      <strong class="file-title">Information</strong>
      <div class="file-content-hd">
        <h2 class="fs-1">서비스 정보 설정</h2>
        <p class="info-txt">플래너 정보 변경은 관리자에 승인 하에 완료됩니다. <br>관리자가 확인 후 24시간 내로 검토가 완료됩니다.</p>
        <a href="" class="btn btn-outline d-inline-flex"><span>서비스 프로필 변경 승인 요청</span></a>
      </div>
      <router-view :menu-items="menuItems[0].children"></router-view>
    </div>
  </div>
</template>

<style scoped>

</style>